<template>
    <div
        class="overflow-hidden rounded-xl bg-slate-50 p-3 dark:bg-slate-800/25"
    >
        <div
            class="mb-3 flex gap-2 border-b border-slate-200 dark:border-slate-700"
        >
            <button
                @click="subTab = 'manage'"
                class="px-3 py-2 text-sm font-medium"
                :class="
                    subTab === 'manage'
                        ? 'border-b-2 border-indigo-500 text-indigo-600 dark:text-indigo-400'
                        : 'text-slate-500 hover:text-slate-700 dark:text-slate-400'
                "
            >
                Permissões
            </button>
            <button
                @click="subTab = 'history'"
                class="px-3 py-2 text-sm font-medium"
                :class="
                    subTab === 'history'
                        ? 'border-b-2 border-indigo-500 text-indigo-600 dark:text-indigo-400'
                        : 'text-slate-500 hover:text-slate-700 dark:text-slate-400'
                "
            >
                Histórico
            </button>
        </div>

        <user-permission-history v-if="subTab === 'history'" :user="user" />

        <div v-show="subTab === 'manage'" class="w-full">
            <div class="mx-auto w-full rounded-2xl">
                <Disclosure v-slot="{ open }">
                    <DisclosureButton
                        class="flex w-full justify-between rounded-lg bg-gray-800 px-4 py-2 text-left text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75"
                    >
                        <span>Administrativo</span>
                        <ChevronUpIcon
                            :class="open ? 'rotate-180 transform' : ''"
                            class="h-5 w-5 text-white"
                        />
                    </DisclosureButton>
                    <DisclosurePanel class="px-1 pb-2 pt-4 text-sm">
                        <div
                            class="mb-3 rounded-xl border border-slate-200 bg-white px-4 pb-1 pt-4 dark:border-slate-800 dark:bg-slate-900"
                        >
                            <form-toggle
                                v-model="admin_panel"
                                :loading="loading"
                                label="Acesso Administrativo"
                            />
                            <p
                                class="-mt-2 mb-4 text-xs text-slate-500 dark:text-slate-400"
                            >
                                Essa chave entra em vigor na hora, sem precisar
                                salvar.
                            </p>

                            <div
                                v-if="roles.length"
                                class="border-t border-slate-200 pt-4 dark:border-slate-800"
                            >
                                <p
                                    class="mb-3 text-[13px] font-semibold text-slate-700 dark:text-slate-100"
                                >
                                    Setores
                                </p>
                                <div
                                    class="grid grid-cols-1 gap-x-6 md:grid-cols-2 xl:grid-cols-3"
                                >
                                    <form-toggle
                                        v-for="role in roles"
                                        :key="role.id"
                                        v-model="role.has"
                                        :loading="loading"
                                        :label="role.name"
                                    />
                                </div>
                            </div>
                        </div>

                        <p
                            v-if="can_manage_restricted"
                            class="mb-3 flex items-center gap-2 text-xs text-amber-600 dark:text-amber-400"
                        >
                            <span
                                class="inline-block h-3 w-0.5 rounded-full bg-amber-400"
                            ></span>
                            Você enxerga as permissões restritas, marcadas com o
                            selo "restrita".
                        </p>

                        <permission-group-list
                            v-if="admin_panel"
                            ref="adminPermissions"
                            :permissions="permissions"
                            :loading="loading"
                            :dirty="rolesChanged"
                            dirty-label="Setores alterados"
                            v-model:reason="reasonAdmin"
                            placeholder="Buscar permissão: saque, produto, webhook..."
                            @save="updatePermissions"
                        />
                        <p
                            v-else
                            class="rounded-xl border border-dashed border-slate-300 py-8 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400"
                        >
                            Ligue o acesso administrativo para liberar as
                            permissões do painel.
                        </p>
                    </DisclosurePanel>
                </Disclosure>
                <Disclosure as="div" class="mt-2" v-slot="{ open }">
                    <DisclosureButton
                        class="flex w-full justify-between rounded-lg bg-gray-800 px-4 py-2 text-left text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75"
                    >
                        <span>Produtor</span>
                        <ChevronUpIcon
                            :class="open ? 'rotate-180 transform' : ''"
                            class="h-5 w-5 text-white"
                        />
                    </DisclosureButton>
                    <DisclosurePanel
                        class="flex flex-col px-4 pb-2 pt-4 text-sm text-gray-500"
                    >
                        <form-toggle
                            v-model="is_producer"
                            :loading="loading"
                            label="Cria Produtos ?"
                        ></form-toggle>

                        <label
                            class="mb-1 mt-3 block text-sm font-medium text-slate-300"
                        >
                            Motivo (opcional)
                        </label>
                        <textarea
                            v-model="reasonProducer"
                            rows="2"
                            maxlength="500"
                            placeholder="Descreva o motivo desta alteração..."
                            class="mb-3 w-full rounded-md border border-slate-300 bg-white p-2 text-sm dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100"
                        ></textarea>

                        <submit-button
                            @click.prevent="updateProducer"
                            :loading="loading"
                        >
                            Salvar
                        </submit-button>
                    </DisclosurePanel>
                </Disclosure>
                <Disclosure as="div" class="mt-2" v-slot="{ open }">
                    <DisclosureButton
                        class="flex w-full justify-between rounded-lg bg-gray-800 px-4 py-2 text-left text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75"
                    >
                        <span>Outras</span>
                        <ChevronUpIcon
                            :class="open ? 'rotate-180 transform' : ''"
                            class="h-5 w-5 text-white"
                        />
                    </DisclosureButton>
                    <DisclosurePanel
                        class="flex flex-col px-4 pb-2 pt-4 text-sm text-gray-500"
                    >
                        <permission-group-list
                            ref="otherPermissions"
                            :permissions="other_permissions"
                            :loading="loading"
                            v-model:reason="reasonOther"
                            placeholder="Buscar permissão..."
                            @save="updateOtherPermissions"
                        />
                    </DisclosurePanel>
                </Disclosure>
            </div>
        </div>
    </div>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronUpIcon } from "@heroicons/vue/20/solid";
import FormToggle from "../../../components/forms/FormToggle.vue";
import SubmitButton from "../../../components/forms/SubmitButton.vue";
import PermissionGroupList from "./PermissionGroupList.vue";
import UserPermissionHistory from "./UserPermissionHistory.vue";
export default {
    components: {
        SubmitButton,
        FormToggle,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ChevronUpIcon,
        UserPermissionHistory,
        PermissionGroupList,
    },
    props: ["user"],

    data() {
        return {
            watch: false,
            loading: false,
            admin_panel: false,
            is_producer: false,
            roles: [],
            permissions: [],
            other_permissions: [],
            can_manage_restricted: false,
            rolesSnapshot: {},
            subTab: "manage",
            reasonAdmin: "",
            reasonProducer: "",
            reasonOther: "",
        };
    },

    computed: {
        rolesChanged() {
            return this.roles.some(
                (role) => this.rolesSnapshot[role.id] !== role.has,
            );
        },
    },

    watch: {
        admin_panel(val) {
            if (this.watch && !this.loading) {
                this.toggleAdminAccess(val);
            }
        },
    },

    mounted() {
        this.fetch();
    },

    methods: {
        snapshotRoles() {
            this.rolesSnapshot = this.roles.reduce((snapshot, role) => {
                snapshot[role.id] = role.has;

                return snapshot;
            }, {});
        },
        fetch() {
            this.loading = true;
            axios
                .get("/api/user/" + this.user.id + "/permission")
                .then(({ data }) => {
                    this.other_permissions = data.other_permissions;
                    this.can_manage_restricted = data.can_manage_restricted;
                    this.permissions = data.permissions;
                    this.admin_panel = data.admin_panel;
                    this.roles = data.roles;
                    this.snapshotRoles();
                    this.is_producer = data.is_producer;
                    this.loading = false;
                    this.$nextTick(() => {
                        this.watch = true;
                    });
                });
        },
        updateProducer() {
            this.loading = true;
            axios
                .post("/api/user/" + this.user.id + "/permission/producer", {
                    permission: this.is_producer,
                    reason: this.reasonProducer || null,
                })
                .then(({ data }) => {
                    this.loading = false;
                    this.reasonProducer = "";
                    this.$notify(
                        {
                            group: "success",
                            text: "Salvo com sucesso!",
                        },
                        4000,
                    );
                })
                .catch(({ response }) => {
                    this.loading = false;
                    this.is_producer = !this.is_producer;
                    this.$notify(
                        {
                            group: "error",
                            title: "Error",
                            text: response.data.message,
                        },
                        4000,
                    );
                });
        },
        toggleAdminAccess() {
            this.loading = true;
            this.watch = false;
            axios
                .post("/api/user/" + this.user.id + "/permission/admin", {
                    permission: this.admin_panel,
                    reason: this.reasonAdmin || null,
                })
                .then(({ data }) => {
                    this.loading = false;
                    this.reasonAdmin = "";
                    this.$nextTick(() => {
                        this.watch = true;
                    });
                })
                .catch(({ response }) => {
                    this.loading = false;
                    this.admin_panel = !this.admin_panel;
                    this.$nextTick(() => {
                        this.watch = true;
                    });
                    this.$notify(
                        {
                            group: "error",
                            title: "Error",
                            text: response.data.message,
                        },
                        4000,
                    );
                });
        },
        updatePermissions() {
            this.loading = true;
            axios
                .put("/api/user/" + this.user.id + "/permission", {
                    permissions: this.permissions,
                    roles: this.roles,
                    reason: this.reasonAdmin || null,
                })
                .then(() => {
                    this.loading = false;
                    this.reasonAdmin = "";
                    this.snapshotRoles();
                    this.$refs.adminPermissions?.commit();
                    this.$nextTick(() => {
                        this.watch = true;
                    });
                    this.$notify(
                        { group: "success", text: "Permissões salvas." },
                        4000,
                    );
                })
                .catch(({ response }) => {
                    this.loading = false;
                    this.$notify(
                        {
                            group: "error",
                            title: "Error",
                            text:
                                response?.data?.message ??
                                "Não foi possível salvar as permissões.",
                        },
                        4000,
                    );
                });
        },
        updateOtherPermissions() {
            this.loading = true;
            axios
                .put("/api/user/" + this.user.id + "/permission/other", {
                    other_permissions: this.other_permissions,
                    reason: this.reasonOther || null,
                })
                .then(() => {
                    this.loading = false;
                    this.reasonOther = "";
                    this.$refs.otherPermissions?.commit();
                    this.$nextTick(() => {
                        this.watch = true;
                    });
                    this.$notify(
                        { group: "success", text: "Permissões salvas." },
                        4000,
                    );
                })
                .catch(({ response }) => {
                    this.loading = false;
                    this.$notify(
                        {
                            group: "error",
                            title: "Error",
                            text:
                                response?.data?.message ??
                                "Não foi possível salvar as permissões.",
                        },
                        4000,
                    );
                });
        },
    },
};
</script>
